import { RaidSettlementView } from '../shared/RaidSettlementView.jsx';

export function DesktopRaidSettlement() {
  return <RaidSettlementView />;
}
